"use strict";

exports.__esModule = true;
exports.useLayer = useLayer;

var _react = require("react");

var _reactHooks = require("@okee-uikit/react-hooks");

var _layer = require("../context/layer");

function useLayer(toBody) {
  if (toBody === void 0) {
    toBody = false;
  }

  var layer = (0, _react.useContext)(_layer.LayerContext);
  var result = (0, _reactHooks.useContainer)(layer);

  if (!layer || toBody) {
    return function () {
      return typeof window !== 'undefined' ? document.body : null;
    };
  }

  return result;
}